
import Vue from "vue";
import ApiItemDetails from "../components/ApiItemDetails.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import { mapGetters, mapActions } from "vuex";

import { CategoriesData } from "../types";
import { Entry } from "../types";

export default Vue.extend({
  name: "Categories",
  components: {
    ApiItemDetails,
    PulseLoader
  },
  data(): CategoriesData {
    return {
      loading: true,
      itemDetails: true,
      selectedCategory: [],
      selectedValue: "Please, select an option"
    };
  },
  methods: {
    // Map action to the component
    ...mapActions(["getCategories", "getEntries"]),
    // A method to change the value of the select menu according to the selected option
    onChange(value: string) {
      this.selectedCategory = this.allEntries.filter(
        (entry: Entry) => (entry.Category as string) === value
      );
    }
  },
  computed: {
    // Map state to the component
    ...mapGetters(["allEntries", "allCategories"])
  },
  async created() {
    // Call the fetch action
    await this.getCategories();
    await this.getEntries();
    this.loading = false;
  }
});
